<template>
  <v-container>
    <v-alert type="error" icon="fas fa-exclamation" elevation="2" dense :value="error != ''" dismissible>{{error}}</v-alert>
    <v-card elevation="1" outlined class="filterCard">
      <div style="display: inline-flex;">
        <h2 style="margin-bottom: 10px; margin-left: 10px;">Filters</h2>
      </div>
      <div style="display: inline-flex; float: right; margin-right: 10px;">
        <v-btn color="primary" @click="clearFilters()">Clear Filters</v-btn>
      </div>
      <v-row no-gutters>
        <v-col>
          <v-select 
            outlined 
            class="flexiFilter" 
            label="State" 
            :items="states" 
            item-text="StateName" 
            item-value="StateID" 
            v-model="selectedStateID" 
            @change="onSearchChanged" 
            clearable
            :menu-props="{ top: false, offsetY: true }"></v-select>
        </v-col>
        <v-col>
          <v-text-field 
            outlined 
            class="flexiFilter" 
            label="Name" 
            v-model="searchedLocation" 
            @change="onSearchChanged" 
            clearable></v-text-field>
        </v-col>
        <v-col>
          <v-text-field 
            outlined 
            class="flexiFilter" 
            label="Contact" 
            v-model="searchedContact" 
            @change="onSearchChanged" 
            clearable></v-text-field>
        </v-col>
        <v-col>
          <v-text-field 
            outlined 
            class="flexiFilter" 
            label="Email" 
            v-model="searchedEmail" 
            @change="onSearchChanged" 
            clearable></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <LocationList ref="locationListChild" :stateID="selectedStateID" :location="searchedLocation" :contact="searchedContact" :email="searchedEmail"></LocationList>
  </v-container>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator';
import LocationList from '@/components/locations/LocationList.vue';
import State from '../../../shared/models/state'
import * as stateAPI from '@/api/stateAPI';
import { vxm } from '@/store';

@Component({
  components: {
    LocationList
  },
})
export default class LocationView extends Vue{
  $refs!: {
    locationListChild: LocationList
  }

  private error = "";
  private selectedStateID: number | null = null;
  private searchedLocation: string | null = null;
  private searchedContact: string | null = null;
  private searchedEmail: string | null = null;
  private states: State[] = [];

  private async mounted() {
    try {
      this.states = await stateAPI.getStates();
    }
    catch (ex) {
      this.error = (ex as Error).message;
    }
  }

  private async onSearchChanged() {
    this.$refs.locationListChild?.load();
  }

  private clearFilters() {
    this.selectedStateID = null;
    this.searchedLocation = null;
    this.searchedContact = null;
    this.searchedEmail = null;
    this.$refs.locationListChild.load();
  }
  get selectedClientID() { return  vxm.AuthStore.targetClient?.ClientID; }
  
  @Watch('selectedClientID', { immediate: true, deep: true })
  async onClientIDChanged() {
    this.onSearchChanged();
  }
}
</script>

<style>
.flexiFilter {
  margin-left: 10px !important; 
  margin-right: 10px !important; 
  min-width: 200px;
}
.filterCard {
  padding: 12px !important;
  margin-bottom: 30px;
}
</style>